import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ listing }) => {

  const roundMileage = (mileage) => {
    if (mileage < 1000) {
      return `${mileage} miles`;
    } else if (mileage < 1000000) {
      return `${Math.round(mileage / 1000)}k miles`;
    } else {
      return `${Math.round(mileage / 1000000)}m miles`;
    }
  };

  return (
    <div
      key={listing.id}
      className="group relative flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-md hover:shadow-lg transition-shadow duration-300"
    >
      <div className="aspect-w-4 aspect-h-4 bg-gray-200 sm:aspect-none group-hover:opacity-75 sm:h-96 max-h-96 transition-all duration-300">
        {listing.meta_box._al_listing_image_gallery.length > 0 ? (
          <img 
            src={listing.meta_box._al_listing_image_gallery[0].sizes.large.url}
            alt={listing.title.rendered}
            className="h-full w-full object-cover object-center sm:h-full sm:w-full"
            loading="lazy"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center bg-gray-100">
            <span className="text-gray-400">No image available</span>
          </div>
        )}
        
      </div>
      <div className='bg-red-600 py-1'></div>
      <div className="flex flex-1 flex-col space-y-2 p-4">
        
        <h3 className="text-lg font-black text-gray-900">
          <Link to={`/inventory/${listing.id}`} className="group-hover:text-black">
            <span aria-hidden="true" className="absolute inset-0" />
            {listing.title.rendered}
          </Link>
          <br />
          <div className='flex flex-row justify-between'>
          <span className="text-xs text-slate-600 font-normal">
          {listing.meta_box._al_listing_model_vehicle ? `${listing.meta_box._al_listing_model_vehicle} ` : ''}
          {listing.meta_box._al_listing_model_drive ? `${listing.meta_box._al_listing_model_drive} ` : ''} 
          </span>
          <p className="text-xs text-slate-600 font-normal">
            Stock #{listing.acf.stock_no || 'No stock number'}
          </p>
          </div>
        </h3>
        <div className="flex flex-row items-start justify-between">
          <div>

          {listing.meta_box._al_listing_price && listing.meta_box._al_listing_price_status !== 'Sold' ? (
          <p className="text-2xl font-black text-red-600">
            {listing.meta_box._al_listing_price ? `$${Number(listing.meta_box._al_listing_price).toLocaleString()}` : 'Price not available'}
          </p>)
          : (
            <div className="text-xl font-black text-gray-600">
              Sold
            </div>
          )}

          <p className="text-sm text-slate-600 font-semibold">
            {listing.meta_box._al_listing_odometer ? `${roundMileage(listing.meta_box._al_listing_odometer)} ` : 'Mileage not available'}
          </p>
          </div>
          <div className='flex flex-row items-end'></div>
        </div>
        
      </div>
    </div>
  );
};

export default Card;